module.exports = __webpack_public_path__ + "img/logo_navbar.5e38bacf.png";